"use client";

import { PricingApiContext, useProgramMeta } from "@2u-landing-pages/providers";
import {
  TypeTileWithoutUnresolvableLinksResponse
} from "@2u-landing-pages/types";
import cn from "classnames";
import React, { useContext } from "react";
import { Tile } from "../Tile/Tile";
import { TileProps } from "../Tile/Tile.types";
import { AutomatedContentTileProps } from "./AutomatedContent.types";
import { getContentToDisplay } from "./displayContent";
import { StartDatePreview } from "./StartDatePreview";
// @ts-ignore
import acTileStyles from "./AutomatedContent.module.scss";


export const AutomatedContentTile: React.FC<AutomatedContentTileProps> = (props) => {
  const programMeta = useProgramMeta();
  const { pricingApiValues } = useContext(PricingApiContext);
  const {
    className,
    start_date_source,
    start_date_preview,
    tileConfig,
    phoneNumber,
  } = props;

  const programMetaStartDate = props.metaStartDate ?? programMeta?.fields?.start_date;
  const pricingApiStartDate = props.pricingApiStartDate ?? pricingApiValues?.startDate;

  const content = getContentToDisplay({
    ...props,
    metaStartDate: programMetaStartDate,
    pricingApiStartDate,
  });

  if (!content) return null;

  const classNameStr = Array.isArray(className) ? className.join(" ") : className;

  const tileContent = content as TypeTileWithoutUnresolvableLinksResponse;
  const variation = tileContent.fields?.variation;
  const { variationStyles, ...tileConfigRest } = tileConfig ?? {};
  const variationStyle = variation ? variationStyles?.[variation] : undefined;

  const mergedTileConfig: Partial<TileProps> = {
    ...tileConfigRest,
    variation,
  };

  const showPreview = Boolean(start_date_source) && start_date_preview === "True";

  const tileClassName = cn(classNameStr, variationStyle);

  const tile = (
    <Tile
      {...mergedTileConfig}
      content={tileContent}
      padded={mergedTileConfig.padded ?? false}
      className={showPreview ? cn(acTileStyles.tileInner, variationStyle) : tileClassName}
      phoneNumber={phoneNumber}
    />
  );

  if (!showPreview) {
    return tile;
  }

  return (
    <div className={cn(acTileStyles.tileWrapper, classNameStr)}>
      {tile}
      <StartDatePreview
        start_date_source={start_date_source}
        metaStartDate={programMetaStartDate}
        pricingApiStartDate={pricingApiStartDate}
        contentType="tile"
      />
    </div>
  );
};
